import React, { FC, useState } from 'react'
import styled, { css } from 'styled-components'

import { Grid, Box, Text } from '@wirtualna-polska/n2cr-ds'
import AdsLogo from '@ads/front-core/Icons/AdsLogo'
import IconFacebook from '@ads/front-core/Icons/Facebook'
import IconTwitter from '@ads/front-core/Icons/Twitter'
import Linkedin from '@ads/front-core/Icons/Linkedin'
import { TermsModal } from 'components/TermsModal'
import { breakpoints } from '@ads/front-core/constants/breakpoints'
import { lng } from '@ads/front-core/locales'

const Footer: FC = () => {
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false)

  const handleCloseTermsModal = () => setIsTermsModalOpen(false)

  return (
    <footer>
      {isTermsModalOpen && <TermsModal onClose={handleCloseTermsModal} />}

      <GridStyled>
        <LinkAds href="/">
          <AdsLogo width="100%" />
        </LinkAds>
        <Grid>
          <Box styleCss={{ margin: 'auto' }}>
            <TitleSM>{lng('landing:findUs')}</TitleSM>
            <GridLinkSMStyled>
              <LinkSMStyled
                href="https://www.facebook.com/WirtualnaPolska"
                rel="nofollow"
              >
                <IconFacebook />
              </LinkSMStyled>
              <LinkSMStyled
                href="https://twitter.com/wirtualnapolska"
                rel="nofollow"
              >
                <IconTwitter />
              </LinkSMStyled>
              <LinkSMStyled
                href="https://www.linkedin.com/company/wirtualna-polska/mycompany/"
                rel="nofollow"
              >
                <Linkedin />
              </LinkSMStyled>
            </GridLinkSMStyled>
          </Box>
        </Grid>
        <Grid gap="xxxs">
          <Grid columns={1} styleCss={{ margin: 'auto' }}>
            <AddressStyled>
              <TextMoreGrey as="div">ul. Żwirki i Wigury 16,</TextMoreGrey>
              <TextMoreGrey>02-092 Warszawa</TextMoreGrey>
              <EmailSend href="mailto:sales@ads.wp.pl">
                sales@ads.wp.pl
              </EmailSend>
            </AddressStyled>
          </Grid>
        </Grid>
        <GridItemStyled>
          <TextMoreGrey
            styleCss={{ display: 'flex', justifyContent: 'center' }}
          >
            <TextButton onClick={() => setIsTermsModalOpen(true)}>
              {lng('landing:statute')}
            </TextButton>
            <LinkStyled href="https://holding.wp.pl/poufnosc">
              {lng('landing:privacyPolicy')}
            </LinkStyled>
          </TextMoreGrey>
        </GridItemStyled>
      </GridStyled>
    </footer>
  )
}

const GridStyled = styled.div`
  display: grid;
  grid-template-columns: 220px 200px 200px;
  justify-content: center;
  align-items: center;
  gap: 32px;
  padding: 80px;
  row-gap: 60px;

  @media (max-width: ${breakpoints.MOBILE}) {
    grid-template-columns: 1fr;
    padding: 60px 0 20px 0;
    row-gap: 45px;
  }
`

const GridItemStyled = styled(Grid)`
  grid-column-start: 1;
  grid-column-end: 5;
  grid-row-start: 2;
  grid-row-end: 2;

  @media (max-width: ${breakpoints.MOBILE}) {
    grid-column-start: auto;
    grid-column-end: auto;
    grid-row-start: auto;
    grid-row-end: auto;
  }
`

const TextMoreGrey = styled(Text).attrs({ as: 'div' })`
  display: flex;
  justify-content: center;
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  color: #71757d;
  font-size: ${p => p.theme.fontSizes.m}px;
  line-height: ${p => p.theme.space.m}px;
  @media (max-width: ${breakpoints.MOBILE}) {
    font-size: ${p => p.theme.fontSizes.l}px;
    line-height: 29px;
  }
`

const TitleSM = styled(TextMoreGrey)`
  font-size: ${p => p.theme.fontSizes.m}px;
  font-weight: ${p => p.theme.fontWeights.regular}px;

  @media (max-width: ${breakpoints.MOBILE}) {
    font-size: ${p => p.theme.fontSizes.l}px;
  }
`

const linkStyled = css`
  font-family: 'Poppins', sans-serif;
  color: #8a8e94;
  margin: 0 8px;
  text-decoration: none;
  font-size: ${p => p.theme.fontSizes.s}px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: ${breakpoints.MOBILE}) {
    font-size: ${p => p.theme.fontSizes.l}px;
  }
`

const TextButton = styled.div`
  ${linkStyled}
`

const LinkStyled = styled.a`
  ${linkStyled}
`

const EmailSend = styled.a`
  font-family: 'Poppins', sans-serif;
  display: block;
  font-weight: bold;
  color: #ec1c24;
  font-size: 14px;
  line-height: ${p => p.theme.space.m}px;
  text-decoration: none;
  font-style: normal;
  text-align: center;

  &:hover {
    text-decoration: underline;
  }
`

const LinkAds = styled.a`
  margin-left: 60px;
  @media (max-width: ${breakpoints.MOBILE}) {
    display: none;
  }
`

const AddressStyled = styled.address`
  @media (max-width: ${breakpoints.MOBILE}) {
    text-align: center;
  }
`

const GridLinkSMStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 13px;
  gap: 18px;
  align-items: center;
  width: 100px;

  @media (max-width: ${breakpoints.MOBILE}) {
    gap: 14px;
    justify-content: center;
    margin-top: 18px;
    width: auto;
  }
`

const LinkSMStyled = styled.a`
  display: inline-block;
  width: 22px;

  @media (max-width: ${breakpoints.MOBILE}) {
    width: 26px;
  }
`

export default Footer
